import {createReducer, on} from '@ngrx/store';
import {resetAppState, setVersion, setWhitelabel} from './app.action';
import {AppState} from './app.state';

export const initialState: AppState = {
  version: '1.0.0',
  whitelabelInfo: null,
  whitelabelConfig: null,
  whitelabelOverrides: null,
  whitelabelSource: null
};

const appReducer = createReducer(
  initialState,
  on(setVersion, (state, { version }) => ({ ...state, version })),
  on(setWhitelabel, (state, { whitelabelDomainInfo, whitelabelSource }) => {
    if (!whitelabelDomainInfo) {
      return {
        ...state,
        whitelabelInfo: null,
        whitelabelConfig: null,
        whitelabelOverrides: null,
        whitelabelSource: null
      }
    }

    let config: Record<string, any> = {}
    let overrides: Record<string, any> = {}

    whitelabelDomainInfo?.config?.forEach(v => {
      let parsedValue = v.value
      try {
        parsedValue = JSON.parse(v.value)
      } catch {
        parsedValue = v.value
      }

      config[v.key] = parsedValue
    })
    whitelabelDomainInfo?.overrideConfig?.forEach(v => {
      let parsedValue = v.value
      try {
        parsedValue = JSON.parse(v.value)
      } catch {
        parsedValue = v.value
      }

      overrides[v.key] = parsedValue
    })

    return {
      ...state,
      whitelabelInfo: whitelabelDomainInfo.whitelabel,
      whitelabelConfig: config,
      whitelabelOverrides: overrides,
      whitelabelSource: whitelabelSource
    }
  }),
  on(resetAppState, () => initialState)
);

export { appReducer };
